var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.pp ? _vm.pp : 'resources/images/avatars/avatar-2.png'}})}
var staticRenderFns = []

export { render, staticRenderFns }